import Nullstack from 'nullstack';
export default function IconClockPlay({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-clock-play",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 7v5l2 2"
  }), "   ", Nullstack.element("path", {
    d: "M17 22l5 -3l-5 -3z"
  }), "   ", Nullstack.element("path", {
    d: "M13.017 20.943a9 9 0 1 1 7.831 -7.292"
  }), " ");
}